var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dummy",staticClass:"odr-sticky-dummy",class:{'odr-sticky-dummy_stretched': _vm.stretched}},[_c('div',{ref:"sticky",staticClass:"odr-sticky",class:{'odr-sticky_fixed': _vm.fixed,
                  'odr-sticky_stretched': _vm.stretched,
                  'odr-sticky_bottom': _vm.fixed && _vm.onBottom}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }